import {
  I_ACCESS_TOKEN_PARAMS,
  I_COMMON_DELETE_PARAMS,
  I_COMMON_GET_ITEM_PARAMS,
  I_COMMON_CREATE_PARAMS,
  I_COMMON_PUT_PARAMS,
  I_COMMON_IMPORT_PARAMS,
  _customFetch,
  getFetchGETOptions,
  getFetchDELETEOptions,
} from './_base';
import LoggerService,{formatTrace} from '../../LoggerService';
import {I_CHARGE_ACTIVITY_MODEL} from '../interfaces/I_CHARGE_MODELS';
import APP_CONFIG from 'config';

// ---------------------------------
// --- MODELES DE CHARGES
// ---------------------------------

const ENDPOINT_CHARGES_MODELS = '/charges';

const logger = LoggerService.getInstance();

interface I_GET_PARAMS extends I_ACCESS_TOKEN_PARAMS {
  activity_types: string;
  directions_ops: string;  // direction de la charge
  hubs_ops: string;  // pole de direction de la charge
  directions_hr: string;  // direction de l'activité de la charge
  hubs_hr: string;  // pole de direction de l'activité de la charge
  collaborators: string;
  skills: string;
  functions: string;
}
interface I_CHARGE_MODEL_FIELDS {
  /** nom du modele de charge */
  name: string;
  /** description du modele de charge (opt.) */
  description?: string;
  /** type d'activité du modele de charge (opt.) */
  activity_type_id?: number;
  /** volume horaire du modele de charge (opt.) */
  hourly_volume?: number;
  /** direction OPS du modele de charge (opt.) */
  direction?: string;
  /** pole de direction OPS du modele de charge (opt.) */
  hub?: string;
  /** liste des activités du modele de charge (peut etre vide) */
  activities: I_CHARGE_ACTIVITY_MODEL[];
}
interface I_CHARGE_MODEL_POST_PARAMS extends I_COMMON_CREATE_PARAMS, I_CHARGE_MODEL_FIELDS {}
interface I_CHARGE_MODEL_PUT_PARAMS extends I_COMMON_PUT_PARAMS, I_CHARGE_MODEL_FIELDS {}





/**
 * Requete le endpoint charges
 * Récupère la liste des charges
 * @param param0
 */
const get = async ({
  accessToken,page,
  activity_types,
  directions_ops,hubs_ops,directions_hr,hubs_hr,
  collaborators,skills,functions,
}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - charges-models - get...'));
  const options = getFetchGETOptions({accessToken});
  const paramMode = `mode=model`;
  const paramPage = `${page ? '&page=' + page : ''}`;
  const paramActivityTypes = activity_types ? `activity_types=${activity_types}` : '';
  const paramDirectionsOps = directions_ops ? `directions_ops=${directions_ops}` : '';
  const paramHubsOps = hubs_ops ? `hubs_ops=${hubs_ops}` : '';
  const paramDirectionsHr = directions_hr ? `directions_hr=${directions_hr}` : '';
  const paramHubsHr = hubs_hr ? `hubs_hr=${hubs_hr}` : '';
  const paramCollaborators = collaborators ? `collaborators=${collaborators}` : '';
  const paramSkills = skills ? `skills=${skills}` : '';
  const paramFunctions = functions ? `functions=${functions}` : '';
  const paramsAll = [paramMode,paramActivityTypes,paramDirectionsOps,paramHubsOps,paramDirectionsHr,paramHubsHr,paramCollaborators,paramSkills,paramFunctions].join('&');
  const URL = `${ENDPOINT_CHARGES_MODELS}${APP_CONFIG.ENDPOINT_SUFFIX}?${paramsAll}${paramPage}`;
  return _customFetch(URL,options);
};


/**
 * Requete le endpoint charge
 * Récupère le charge
 * @param param0
 * @returns
 */
const getItem = async ({accessToken,id}:I_COMMON_GET_ITEM_PARAMS) => {
  logger.trace(...formatTrace('ApiEndpoints - charges-models - getItem...'));
  const options = getFetchGETOptions({accessToken});
  const URL = `${ENDPOINT_CHARGES_MODELS}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};

/**
 * Requete le endpoint charge POST
 * Ajoute un charge
 * @param param0
 * @returns
 */
export const post = async (args:I_CHARGE_MODEL_POST_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - charges-models - post...'));
  const {
    accessToken,
    name,
    description,
    activity_type_id,
    hourly_volume,
    direction,
    hub,
    activities,
  } = args;
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      model: true,
      name: encodeURIComponent(name.trim()),
      description: encodeURIComponent(description?.trim() || ''), // opt
      activity_type_id, // opt
      hourly_volume,  // opt
      direction: direction ? encodeURIComponent(direction) : undefined, // opt
      hub: hub ? encodeURIComponent(hub) : undefined, // opt
      activities, // opt
    })
  };
  const URL = ENDPOINT_CHARGES_MODELS + APP_CONFIG.ENDPOINT_SUFFIX;
  return _customFetch(URL,params);
};

/**
 * Requete le endpoint charge DELETE
 * Supprime un charge
 * @param param0
 * @returns
 */
const remove = async ({accessToken,id}:I_COMMON_DELETE_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - charges-models - remove...'));
  const options = getFetchDELETEOptions({accessToken});
  const URL = `${ENDPOINT_CHARGES_MODELS}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};

/**
 * Requete le endpoint charge PUT
 * Met à jour un charge
 * @param param0
 * @returns
 */
const put = async (args:I_CHARGE_MODEL_PUT_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - charges-models - put...'));
  const {
    accessToken,
    id,
    name,
    description,
    activity_type_id,
    hourly_volume,
    direction,
    hub,
    activities,
  } = args;
  const params = {
    method: 'PUT',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      model: true,
      name: encodeURIComponent(name.trim()),
      description: encodeURIComponent(description?.trim() || ''), // opt
      activity_type_id, // opt
      hourly_volume,  // opt
      direction: direction ? encodeURIComponent(direction) : undefined, // opt
      hub: hub ? encodeURIComponent(hub) : undefined, // opt
      activities, // opt
    })
  };
  const URL = `${ENDPOINT_CHARGES_MODELS}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params);
};



const chargesModelsEndpoints = {
  get,
  post,
  remove,
  put,
  getItem,
};

export default chargesModelsEndpoints;
